// Guest mode lets unauthenticated users browse public content (Home feed,
// Locations, card details) without an account. Apple 5.1.1(v) compliance —
// registration may only be required for account-based actions.

const KEY = 'cardchase_guest_mode';

export const isGuest = () => {
  try { return localStorage.getItem(KEY) === 'true'; }
  catch (_) { return false; }
};

export const enterGuestMode = () => {
  try { localStorage.setItem(KEY, 'true'); } catch (_) {}
};

export const exitGuestMode = () => {
  try { localStorage.removeItem(KEY); } catch (_) {}
};
